<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const modelValue = ref<boolean>()
const searchQuery = ref('')

function close() {
    modelValue.value = false
    searchQuery.value = ''
}

function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
        close()
    }
}

onMounted(() => {
    window.addEventListener('keydown', onKeydown)
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', onKeydown)
})
</script>

<template>
    <v-dialog v-model="modelValue" width="860" transition="fade-transition">
        <v-card class="pa-6 rounded-xl">
            <!-- Search Bar -->
            <div class="d-flex align-center mb-6">
                <v-icon class="mr-3">mdi-magnify</v-icon>
                <v-text-field v-model="searchQuery" class="flex-grow-1" placeholder="Search..." variant="underlined"
                    hide-details />
                <span class="ml-3 text-caption text-medium-emphasis">[esc]</span>
            </div>

            <v-row>
                <!-- Popular Searches -->
                <v-col cols="6" sm="3">
                    <div class="text-caption text-medium-emphasis font-weight-bold mb-2">POPULAR SEARCHES</div>
                    <v-list density="compact">
                        <v-list-item title="Analytics" prepend-icon="mdi-chart-line" />
                        <v-list-item title="CRM" prepend-icon="mdi-timer-outline" />
                        <v-list-item title="eCommerce" prepend-icon="mdi-cart-outline" />
                        <v-list-item title="Logistics" prepend-icon="mdi-truck-outline" />
                    </v-list>
                </v-col>

                <!-- Apps & Pages -->
                <v-col cols="6" sm="3">
                    <div class="text-caption text-medium-emphasis font-weight-bold mb-2">APPS & PAGES</div>
                    <v-list density="compact">
                        <v-list-item title="Calendar" prepend-icon="mdi-calendar-outline" />
                        <v-list-item title="Roles & Permissions" prepend-icon="mdi-shield-account" />
                        <v-list-item title="Account Settings" prepend-icon="mdi-cog-outline" />
                        <v-list-item title="Dialog Examples" prepend-icon="mdi-comment-processing-outline" />
                    </v-list>
                </v-col>

                <!-- User Interface -->
                <v-col cols="6" sm="3">
                    <div class="text-caption text-medium-emphasis font-weight-bold mb-2">USER INTERFACE</div>
                    <v-list density="compact">
                        <v-list-item title="Typography" prepend-icon="mdi-format-text" />
                        <v-list-item title="Accordion" prepend-icon="mdi-view-parallel-outline" />
                        <v-list-item title="Alerts" prepend-icon="mdi-alert-outline" />
                        <v-list-item title="Cards" prepend-icon="mdi-credit-card-outline" />
                    </v-list>
                </v-col>

                <!-- Radio & Tables -->
                <v-col cols="6" sm="3">
                    <div class="text-caption text-medium-emphasis font-weight-bold mb-2">RADIO & TABLES</div>
                    <v-list density="compact">
                        <v-list-item title="Radio" prepend-icon="mdi-radiobox-marked" />
                        <v-list-item title="Form Layouts" prepend-icon="mdi-form-select" />
                        <v-list-item title="Table" prepend-icon="mdi-table" />
                        <v-list-item title="Editor" prepend-icon="mdi-square-edit-outline" />
                    </v-list>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.v-list-item {
    border-radius: 8px;
    transition: background-color 0.2s ease;
}

.v-list-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
}
</style>